import { render, staticRenderFns } from "./ConfigFunction.vue?vue&type=template&id=31782f29&scoped=true"
import script from "./ConfigFunction.vue?vue&type=script&lang=js"
export * from "./ConfigFunction.vue?vue&type=script&lang=js"
import style0 from "./ConfigFunction.vue?vue&type=style&index=0&id=31782f29&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31782f29",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31782f29')) {
      api.createRecord('31782f29', component.options)
    } else {
      api.reload('31782f29', component.options)
    }
    module.hot.accept("./ConfigFunction.vue?vue&type=template&id=31782f29&scoped=true", function () {
      api.rerender('31782f29', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schoolconfig/ConfigFunction.vue"
export default component.exports